import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'ln-hero-image-container',
  imports: [NgOptimizedImage],
  templateUrl: './ln-hero-image-container.component.html',
  styleUrl: './ln-hero-image-container.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnHeroImageContainerComponent {
  @Input() imgUrl = '';
}
